import dateUtil from "@/utils/date.js"

export const mesAchatsFiltersProps = () => ({
  listeMagasins: {
    type: Array,
    required: false,
    default: () => []
  },
  appliedFilters: {
    type: Array,
    required: false,
    default: () => []
  },
  queryFilters: {
    type: Object,
    required: false,
    default: () => { }
  },
  keyPeriode: {
    type: String,
    required: false,
    default: ""
  }
})

export const mesAchatsFiltersEmits = () => ([
  "appliquerFiltres"
])

export const useMesAchatsFilters = (props, context) => {
  const dateMinInput = ref("")
  const dateMaxInput = ref("")
  const montantMinInput = ref("")
  const montantMaxInput = ref("")
  const garantieInput = ref(false)
  const searchWord = ref("")
  const libellePeriode = ref(null)
  const filtreMontants = ref({
    montant_total_ttc_min: null,
    montant_total_ttc_max: null
  })
  const filtrePeriode = ref({
    date_min: null,
    date_max: null
  })
  const filtreMagasin = ref({
    mag_id: null
  })
  const filtreGarantie = ref({
    garantie: 0
  })
  const dateSelectorDisabled = computed(() => {
    return libellePeriode.value !== 'custom' || (dateMaxInput.value < dateMinInput.value && dateMaxInput.value) || (!dateMinInput.value && !dateMaxInput.value)
  })
  const montantSelectorDisabled = computed(() => {
    return (parseFloat(montantMaxInput.value) === 0 && parseFloat(montantMinInput.value) === 0) || (parseFloat(montantMinInput.value) > parseFloat(montantMaxInput.value) && parseFloat(montantMaxInput.value) !== '')
  })
  const magasinsSearchResult = computed(() => {
    return props.listeMagasins.filter((filter) => filter.attributes.magasin.toLowerCase().includes(searchWord.value));
  })

  const searchMagasin = (value) => {
    searchWord.value = value.toLowerCase()
  }
  const updateDate = () => {
    const today = new Date()
    switch (libellePeriode.value) {
      case "thisMonth":
        filtrePeriode.value.date_min = dateUtil.formatRedevanceDate(dateUtil.startOf(today, 'month'))
        filtrePeriode.value.date_max = dateUtil.formatRedevanceDate(dateUtil.endOf(today, 'month'))
        break
      case "lastMonth":
        filtrePeriode.value.date_min = dateUtil.formatRedevanceDate(dateUtil.startOf(dateUtil.subtract(today, 'month', 1), 'month'))
        filtrePeriode.value.date_max = dateUtil.formatRedevanceDate(dateUtil.endOf(dateUtil.subtract(today, 'month', 1), 'month'))
        break
      case "lastThreeMonth":
        filtrePeriode.value.date_min = dateUtil.formatRedevanceDate(dateUtil.startOf(dateUtil.subtract(today, 'month', 2), 'month'))
        filtrePeriode.value.date_max = dateUtil.formatRedevanceDate(dateUtil.endOf(today, 'month'))
        break
      case "custom":
        if (dateMinInput.value !== "") {
          filtrePeriode.value.date_min = dateMinInput.value
        } else {
          filtrePeriode.value.date_min = null
        }
        if (dateMaxInput.value !== "") {
          filtrePeriode.value.date_max = dateMaxInput.value
        } else {
          filtrePeriode.value.date_max = null
        }
        break
      default:
        filtrePeriode.value.date_min = null
        filtrePeriode.value.date_max = null
    }
    if (libellePeriode.value !== "") {
      context.emit('appliquerFiltres', filtrePeriode.value, libellePeriode.value)
    }
  }
  const updateMontant = () => {
    filtreMontants.value.montant_total_ttc_max = montantMaxInput.value ? montantMaxInput.value : null
    filtreMontants.value.montant_total_ttc_min = montantMinInput.value ? montantMinInput.value : null
    context.emit('appliquerFiltres', filtreMontants.value)
  }
  const updateMagasin = () => {
    context.emit('appliquerFiltres', filtreMagasin.value)
  }
  const updateGarantie = (value) => {
    filtreGarantie.value.garantie = value ? 1 : 0
    context.emit('appliquerFiltres', filtreGarantie.value)
  }
  const syncFiltres = () => {
    montantMinInput.value = props.queryFilters.montant_total_ttc_min ? props.queryFilters.montant_total_ttc_min : ""
    montantMaxInput.value = props.queryFilters.montant_total_ttc_max ? props.queryFilters.montant_total_ttc_max : ""
    dateMinInput.value = props.queryFilters.date_min && props.keyPeriode === "custom" ? props.queryFilters.date_min : ""
    dateMaxInput.value = props.queryFilters.date_max && props.keyPeriode === "custom" ? props.queryFilters.date_max : ""
    libellePeriode.value = (props.queryFilters.date_min || props.queryFilters.date_max) ? props.keyPeriode : ""
    filtreMagasin.value.mag_id = props.queryFilters.mag_id ? props.queryFilters.mag_id : null
    garantieInput.value = props.queryFilters.garantie === '1'
  }

  watch(() => props.queryFilters, () => { syncFiltres() })

  return {
    dateMinInput,
    dateMaxInput,
    montantMinInput,
    montantMaxInput,
    garantieInput,
    searchWord,
    libellePeriode,
    filtreMontants,
    filtrePeriode,
    filtreMagasin,
    filtreGarantie,
    dateSelectorDisabled,
    montantSelectorDisabled,
    magasinsSearchResult,
    searchMagasin,
    updateDate,
    updateMontant,
    updateMagasin,
    updateGarantie,
    syncFiltres
  }
}